
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Conference2021/312",
      function () {
        return require("private-next-pages/Conference2021/312/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Conference2021/312"])
      });
    }
  